import { Pattern } from "../pattern/pattern";
import { PhonemeInfo } from "../pattern/phonemeInfo";
import { MatchedIpa, searchAndReplace } from "../pattern/searchAndReplace";
import { IpaType, isStress, syllableBreak } from "../phonemes/ipa";
import { CompiledRule } from "./compileRule";

/**
 * apply a rule to a set of ipa phonemes to derive new phonemes;
 * don't replace a phoneme if it was previously replaced;
 */
export function applyRuleToWord(
  input: MatchedIpa, rule: CompiledRule, subsetMatches?: boolean, ignoreNumbers?: '#'
): MatchedIpa {
  const pattern: Pattern<PhonemeInfo> = rule.from.length === 1 && rule.from[0] === '.' ? { special: 'syllable' }
    : subsetMatches ? { ipa: rule.from, subset: true } : { ipa: rule.from };
  return searchAndReplace(
    input,
    {
      pattern,
      previous: rule.context?.previous,
      next: rule.context?.next,
      syllable: rule.context?.syllable,
    },
    rule.to,
    ignoreNumbers === '#' ? ignorePlus : ignore,
    rule.post
  );
}

/** symbols that can typically be ignored during pattern match, unless explicitly requested */
function ignore(ipa: IpaType): boolean {
  return isStress(ipa) || ipa === syllableBreak;
}
function ignorePlus(ipa: IpaType): boolean {
  const c = ipa && ipa.charAt(0);
  return isStress(ipa) || ipa === syllableBreak || ('0' <= c && c <= '9');
}
